import { VariableValue } from 'product_modules/api/Types';
import { CorrespondenceChecker } from './Types';

const isCorrespondsBoolean: CorrespondenceChecker<boolean> = (value: VariableValue): value is boolean => {
  return typeof value === 'boolean';
};

export default isCorrespondsBoolean;
